<medpace-page [isFullHeight]="true" [isFullWidth]="true" [additionalClasses]="'gap-medpace'">
    <h1>Dashboard</h1>

    <medpace-sites-list [statuses]="routeStatuses()" class="flex h-full" />
</medpace-page>
